import React from 'react';
import { useEffect, useState } from "react";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import DocumentCard from './DocumentCard'; // Assuming you have a DocumentCard component
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';

import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';



const tooltipContent = (
  <Typography>
    Selected documents will be referred to while answering your queries.
  </Typography>
);

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem', color: '#fff' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(2),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
  background: '#000'
}));


const darkTheme = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: "50vh",
  },
  modalContent: {
    backgroundColor: '#343a40',
    padding: '24px', // Increased padding
    borderRadius: '8px',
    color: '#000',
    width: '80%', // Increased width
    maxHeight: '80%', // Set maximum height
    overflowY: 'auto', // Enable vertical scrolling if needed
  },
  documentCard: {
    backgroundColor: '#000',
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '16px',
  },
};

const ModalComponent = ({ open, handleClose, availableDocuments, docTypeGroupedDocuments, selectedDocuments, handleSelectDocument, selectedTickers }) => {

  const [expanded, setExpanded] = React.useState('2024');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const section_counter = 1

  return (
    <Modal
      aria-labelledby="spring-modal-title"
      aria-describedby="spring-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      // BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={darkTheme.modal}
      id="delv-modal"
    >
      <Fade in={open}>
        <Box sx={darkTheme.modalContent} >
        <Box sx={{display: "flex", alignItems: "center"}}>

          <Typography id="spring-modal-title" sx={{display:"inline"}} variant="h6" component="h2">
            Select Documents 
          </Typography>
          &nbsp;
          
          <Tooltip placement="right-start" arrow title={tooltipContent} >
            <HelpOutlineIcon  iconposition="end" sx={{color: "#fff"}} />
          </Tooltip>
          <Tooltip placement="right-start" arrow title='close modal' >
            <CloseIcon sx={{ cursor: 'pointer', marginLeft: 'auto', float:"right", color: "#fff" }} onClick={handleClose}/>
          </Tooltip >
        </Box >
          

          <Typography  sx={{marginBottom:"1rem", color:"orange", textAlign:"center", }} variant="h6" component="h3">
            {selectedTickers[0]?.value?.split(" - ")[0].trim()}
          </Typography>
          
          {/* {Object.keys(availableDocuments)?.map((documentYear) => (
              <Accordion sx={{ background:"rgba(0, 0, 0, 0.5)"  }} key={documentYear} expanded={expanded === documentYear} onChange={handleChange(documentYear)}>
              <AccordionSummary aria-controls={`${documentYear}-content`} id={`${documentYear}-header`}>
                <Typography className={`accordionDetailsTypography `} sx={{ color: `${expanded === documentYear ? 'orange' : 'white'}` }}>Year {documentYear}</Typography>
              </AccordionSummary>
              <AccordionDetails >
                <Box className= {`document-wraper`} sx={{display:"flex", textAlign:"center"}}>
                    {availableDocuments[documentYear].map((document) => (
                      <FormControlLabel
                        sx={{ display: 'flex', flexDirection: 'row', ml: 3, color:"#fff" }}
                        key={document?.doc_id}
                        label= {`${document?.doc_type}-${new Date(0, document?.month).toLocaleString('default', { month: 'short' })}-${documentYear}`}
                        control={<Checkbox checked={selectedDocuments.includes(document?.doc_id)}
                          onChange={()=> handleSelectDocument(document)} 
                          sx={{  color:"#fff" }}
                        />}
                      />
                        
                    ))}
                  </Box>

              </AccordionDetails>
            </Accordion>
          ))} */}

          <div className="row">
          {Object.keys(docTypeGroupedDocuments)?.map((documentType) => (
            <div className="col-lg-4" key={documentType}>
              <Box className=" add-section-container mb-5 add-section-container-docs" >
                <Box>
                  <h2 className="add-section-container__heading">{documentType}</h2>
                </Box>
                <ol className="pl-0" id="added-section-container">
                {docTypeGroupedDocuments[documentType].map((document) => (

                  <li id={`added-section-${section_counter}`} className="add-section-item" key={document.doc_id}> 
                
                    <Box className="add-section-container__div">
                      <FormControlLabel
                          sx={{ display: 'flex', flexDirection: 'row', color:"#fff" }}
                          key={document?.doc_id}
                          label= {`${documentType === "Annual Report" ? "Financial Year": documentType }-${ documentType === "Annual Report" ? "" : new Date(0, document?.month).toLocaleString('default', { month: 'short' })}-${document?.year}`}
                          control={<Checkbox checked={selectedDocuments.includes(document?.doc_id)}
                          onChange={()=> handleSelectDocument(document)} 
                          sx={{  color:"#fff" }}
                          />}
                          />
                    {/* <i className="bi bi-pencil-square add-section-container__icon" id={`update-added-section-${section_counter}`} onClick={() => handle click}></i> */}
                    {/* <i className="bi bi-trash add-section-container__icon" id={`delete-added-section-${section_counter}`} onClick={() => handle click}></i> */}
                    </Box>
                  </li>
                  ))}
                </ol>
              </Box>
            </div>
          ))}
          </div>

        </Box>
      </Fade>
    </Modal>
  );
};

export default ModalComponent;